(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["price-filter"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", () => {
  const inputs = document.querySelectorAll(".js-price-input");
  inputs.forEach(input => {
    input.addEventListener("input", () => {
      // Strip commas automatically on typing/pasting
      input.value = input.value.replace(/,/g, "");
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
